var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('Title',{attrs:{"title":"居家服务全流程"}}),_c('div',{staticClass:"layout-view withoutTitle jujiafuwuquanliucheng"},[_c('div',{staticClass:"components-layout"},[_c('img',{attrs:{"src":"/images/service_process.png"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }